import { ReactNode } from "react";

import { useCurrentWorkspace } from "@accurx/auth";
import { PatientDemographics, getEmbedMode } from "@accurx/native";
import { Log } from "@accurx/shared";
import { FullscreenLayout } from "domains/inbox/components/FullscreenLayout/FullscreenLayout";
import { ROUTES_INBOX } from "domains/inbox/routes";
import { Redirect, generatePath, useLocation } from "react-router";

import { AddNotePatientHeader } from "./PatientHeader";

type NewNoteFullscreenPageProps = {
    children: ReactNode;
};

export const NewNoteFullscreenPage = ({
    children,
}: NewNoteFullscreenPageProps) => {
    const workspaceId = useCurrentWorkspace().orgId;
    const embedMode = getEmbedMode();
    const location = useLocation<{ patient?: PatientDemographics }>();
    const { patient } = location.state;

    if (embedMode === "Desktop" && !patient) {
        Log.error(
            "User attempted to start a conversation with a note but the patient was not found",
        );
    }

    /**
     * Redirect if we
     * - aren't on Desktop
     * - can't find the patient
     */
    if (embedMode !== "Desktop" || !patient) {
        const pathname = generatePath(ROUTES_INBOX.MyInbox, { workspaceId });
        return <Redirect to={pathname} />;
    }

    return (
        <FullscreenLayout header="New Note">
            <AddNotePatientHeader patient={patient} />
            {children}
        </FullscreenLayout>
    );
};
